import { render } from "./CertStatsSection.vue?vue&type=template&id=73c56721&scoped=true"
import script from "./CertStatsSection.vue?vue&type=script&lang=js"
export * from "./CertStatsSection.vue?vue&type=script&lang=js"

import "./CertStatsSection.vue?vue&type=style&index=0&id=73c56721&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c56721"]])

export default __exports__